module.exports = __webpack_public_path__ + "static/media/Template_39.03908fe0.png";